// import Swiper from 'swiper';
// import 'swiper/css';

const swiper = new Swiper('.news-carousel-object', {
    loop: true,
    autoplay: {
        delay: 7000,
    },
    // effect: 'fade',
    // crossFade: true,
    // centeredSlides: true,
    // slidesPerView: 3,
    // coverflowEffect: {
    //     rotate: -10,
    //     stretch: 70,
    //     depth: 100,
    //     modifier: 1,
    //     slideShadows : false
    // },
    // perSlideOffset: 50,
    // perSlideRotate: 0,

    // If we need pagination
    // pagination: {
    //     el: '.swiper-pagination',
    // },

    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

    // And if we need scrollbar
    // scrollbar: {
    //     el: '.swiper-scrollbar',
    // },
});
